import { createAction } from 'redux-act'

export const receiveMockState = createAction()
